import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import { InternalLink } from "../../shared/components/InternalLink";
import { brand, isReallyChitty } from "../../shared/util/branding";

export function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        background: brand.colors.footerBackground,
        py: 6,
        borderTop: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={4}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box>
              <Typography
                variant="h6"
                sx={{ color: theme.palette.text.primary, mb: 1 }}
              >
                {brand.name}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: theme.palette.text.secondary }}
              >
                {brand.tagline}
              </Typography>
            </Box>
            <Stack direction="row" spacing={4}>
              <Stack spacing={1}>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 600,
                  }}
                >
                  Explore
                </Typography>
                <InternalLink to="/features">Features</InternalLink>
                <InternalLink to="/game">Games</InternalLink>
                {isReallyChitty() && <InternalLink to="/develop">Develop</InternalLink>}
              </Stack>
              <Stack spacing={1}>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 600,
                  }}
                >
                  Support
                </Typography>
                <InternalLink to="/contact">Contact</InternalLink>
                <InternalLink to="/privacy">Privacy</InternalLink>
                <InternalLink to="/terms">Terms</InternalLink>
              </Stack>
            </Stack>
          </Stack>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              textAlign: "center",
            }}
          >
            © {new Date().getFullYear()} {brand.name}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
